/* ============================================================
   Eiréné | Curseur custom contextuel (vanilla, sans GSAP)
   Désactivé sur touch et reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  const isTouch = matchMedia('(hover: none)').matches;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (isTouch || reduced) return;

  const cursor = document.querySelector('.eirene-cursor');
  if (!cursor) return;

  let tx = 0, ty = 0, cx = 0, cy = 0;
  function loop() {
    cx += (tx - cx) * 0.18;
    cy += (ty - cy) * 0.18;
    cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
    requestAnimationFrame(loop);
  }
  window.addEventListener('mousemove', (e) => { tx = e.clientX; ty = e.clientY; }, { passive: true });
  loop();

  document.addEventListener('mouseover', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('a, button, [role="button"]')) cursor.dataset.mode = 'link';
    else if (t.closest('img, picture, [data-eirene-image-reveal]')) cursor.dataset.mode = 'image';
    else cursor.dataset.mode = 'default';
  }, { passive: true });
})();
